export default "__VITE_ASSET__DlIxKlZs__"